import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';


const sidebarStyles = makeStyles((theme) => ({
  drawer: {
    width: '270px'
  },
  paper: {
    backgroundColor: theme.palette.background.sidebar,
    position: 'static'
  }
}));

const SideBar = ({ children }) => {
  const classes = sidebarStyles();

  return (
    <Drawer
      variant="permanent"
      classes={{
        root: classes.drawer,
        paper: classes.paper,
      }}
    >
      {children}
    </Drawer>
  );
};

SideBar.propTypes = {
  children: PropTypes.any
}

export default SideBar;
